import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "pricing",
  class: "pricing-wrap style1 pb-75"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = {
  class: "pricing-table style2",
  style: {"{\n                'background-image'":"`url(../../assets/images/pricing-bg-1.jpg)`,"}
}
const _hoisted_5 = { class: "pricing-header-wrap" }
const _hoisted_6 = { class: "pricing-icon" }
const _hoisted_7 = { class: "pricing-header" }
const _hoisted_8 = { class: "pricing-features" }
const _hoisted_9 = { class: "list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
            _createElementVNode("span", null, "Our Pricing Plan"),
            _createElementVNode("h2", null, "Our High Quality Easy Price Without Any Hidden Fees")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricings, (pricing) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: pricing.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(pricing.icon)
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h5", null, _toDisplayString(pricing.title), 1),
                  _createElementVNode("h2", null, [
                    _createTextVNode(" $" + _toDisplayString(pricing.price), 1),
                    _createElementVNode("span", null, "/per " + _toDisplayString(pricing.period), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", null, "Our Best Features", -1)),
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pricing.features, (feature) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: feature.id,
                      class: _normalizeClass(feature.class)
                    }, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-check-double-line" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(feature.text), 1)
                    ], 2))
                  }), 128))
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "purchase-pricing" }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn style1"
                }, "Choose This Plan")
              ], -1))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}